export default () => {
  const defaultDuration = 300;

  const _slideUp = ($el, duration = defaultDuration) => {
    $el.style.height = $el.offsetHeight + 'px';
    $el.offsetHeight;
    $el.style.transitionProperty = 'height, margin, padding';
    $el.style.transitionDuration = duration + 'ms';
    $el.style.transitionTimingFunction = 'ease';
    $el.style.overflow = 'hidden';
    $el.style.height = 0;
    $el.style.paddingTop = 0;
    $el.style.paddingBottom = 0;
    $el.style.marginTop = 0;
    $el.style.marginBottom = 0;
    setTimeout(() => {
      $el.style.display = 'none';
      $el.style.removeProperty('height');
      $el.style.removeProperty('padding-top');
      $el.style.removeProperty('padding-bottom');
      $el.style.removeProperty('margin-top');
      $el.style.removeProperty('margin-bottom');
      $el.style.removeProperty('overflow');
      $el.style.removeProperty('transition-duration');
      $el.style.removeProperty('transition-property');
      $el.style.removeProperty('transition-timing-function');
    }, duration);
  };

  const _slideDown = ($el, duration = defaultDuration) => {
    $el.style.removeProperty('display');
    let display = window.getComputedStyle($el).display;
    if (display === 'none') {
      display = 'block';
    }
    $el.style.display = display;
    let height = $el.offsetHeight;
    $el.style.overflow = 'hidden';
    $el.style.height = 0;
    $el.style.paddingTop = 0;
    $el.style.paddingBottom = 0;
    $el.style.marginTop = 0;
    $el.style.marginBottom = 0;
    $el.offsetHeight;
    $el.style.transitionProperty = 'height, margin, padding';
    $el.style.transitionDuration = duration + 'ms';
    $el.style.transitionTimingFunction = 'ease';
    $el.style.height = height + 'px';
    $el.style.removeProperty('padding-top');
    $el.style.removeProperty('padding-bottom');
    $el.style.removeProperty('margin-top');
    $el.style.removeProperty('margin-bottom');
    setTimeout(() => {
      $el.style.removeProperty('height');
      $el.style.removeProperty('overflow');
      $el.style.removeProperty('transition-duration');
      $el.style.removeProperty('transition-property');
      $el.style.removeProperty('transition-timing-function');
    }, duration);
  };

  const slideToggle = ($el, duration = defaultDuration) => {
    if (window.getComputedStyle($el).display === 'none') {
      _slideDown($el, duration);
    } else {
      _slideUp($el, duration);
    }
  };

  // const element = document.querySelectorAll('.toggle-content');
  const slideToggleBtn = document.querySelectorAll('.toggle-button');
  slideToggleBtn.forEach($el => {
    const targetId = $el.id.replace('toggle-button__', 'toggle-content__');
    const $slideContent = document.getElementById(targetId);
    $el.addEventListener('click', () => {
      slideToggle($slideContent, 300);
    });
  });
}
